import * as Yup from 'yup';

export const sharedTestSchemaValidation = (isSuperAdmin: boolean) => {
  return Yup.object().shape({
    name: Yup.string().when('pageType', {
      is: (pageType: string) => pageType === 'Homepage' && !isSuperAdmin,
      then: (schema) =>
        schema
          .matches(
            /^((https?:\/\/)?(www\.|p6-qa\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/[a-zA-Z0-9_-]+)?)\/?$/,
            'Invalid Home Page URL'
          )
          .required('URL is required'),
      otherwise: (schema) =>
        schema
          .matches(
            /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/,
            'Invalid URL'
          )
          .test({
            name: 'not-anchor-link',
            test: (value) => {
              return !!value && (!value.includes('#') || value.includes('/#/'));
            },
            message: 'Please check URL again. Please put a link for the entire page, not an anchor link.'
          })
          .required('URL is required')
    }),
    pageType: Yup.string().required('Page type is required'),
    label: Yup.string().when('pageType', {
      is: (pageType: string) =>
        pageType === 'brokenlink' || pageType === 'Common' || pageType === 'pre-qa' || pageType === 'pd-pre-qa',
      then: (schema) =>
        schema.test('label', 'Only content, gnb, footer is allowed', (value) => {
          if (value) {
            const labels = value.split('&');
            return labels.every((label) => ['content', 'gnb', 'footer'].includes(label));
          }
          return true;
        }),
      otherwise: (schema) =>
        schema.test('label', 'Only OTK or checklist is allowed', (value) => {
          if (value) {
            const labels = value.split('&');
            return labels.every((label) => ['otk', 'checklist'].includes(label));
          }
          return true;
        })
    })
  });
};
